/**
 * 图标选择器组件
 */

import React, { useState, useEffect } from 'react';
import { Modal, Input, Row, Col, Button, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

interface IconSelectorProps {
  visible: boolean;
  onClose: () => void;
  onSelect: (icon: string) => void;
  currentIcon?: string;
}

// 根据本地iconfont库的实际图标列表（从iconfont.json提取）
const iconList = [
  // 基础图标
  { name: '首页', icon: '&#xe600;', code: 'shouye1' },
  { name: '菜单', icon: '&#xe60e;', code: 'caidan' },
  { name: '授权', icon: '&#xe618;', code: 'shouquan' },
  { name: '角色管理', icon: '&#xe636;', code: 'jiaoseguanli' },
  { name: 'my', icon: '&#xe635;', code: 'my' },
  { name: 'natice', icon: '&#xe65e;', code: 'natice' },
  { name: '短信', icon: '&#xe647;', code: 'duanxin' },
  { name: '信息', icon: '&#xe649;', code: 'xinxi' },
  { name: '想去', icon: '&#xe64c;', code: 'xiangqu' },
  { name: '导航', icon: '&#xe651;', code: 'daohang' },
  { name: '地址', icon: '&#xe652;', code: 'dizhi' },
  { name: '个人', icon: '&#xe657;', code: 'geren' },
  { name: '日志', icon: '&#xe668;', code: 'rizhi' },
  { name: '删除', icon: '&#xe68e;', code: 'shanchu' },
  { name: '设置', icon: '&#xe68f;', code: 'shezhi' },
  { name: '搜索', icon: '&#xe693;', code: 'sousuo' },
  { name: '综合', icon: '&#xe69e;', code: 'zonghe' },
  { name: 'email', icon: '&#xe69f;', code: 'email' },
  { name: '减', icon: '&#xe6a0;', code: 'jian' },
  { name: '关闭', icon: '&#xe6a1;', code: 'RectangleCopy' },
  { name: '完成', icon: '&#xe6a2;', code: 'RectangleCopy1' },
  { name: '搜索', icon: '&#xe6a3;', code: 'RectangleCopy2' },
  { name: '消息', icon: '&#xe6a4;', code: 'RectangleCopy3' },
  { name: '用户', icon: '&#xe6a5;', code: 'RectangleCopy4' },
  { name: '安全', icon: '&#xe6a6;', code: 'RectangleCopy5' },
  { name: '数据', icon: '&#xe6a7;', code: 'RectangleCopy6' },
  { name: 'favorite', icon: '&#xe6a8;', code: 'favorite' },
  { name: '能力', icon: '&#xe6a9;', code: 'RectangleCopy8' },
  { name: 'form', icon: '&#xe6aa;', code: 'form' },
  { name: '下拉', icon: '&#xe6ab;', code: 'RectangleCopy10' },
  { name: '注意', icon: '&#xe6ac;', code: 'RectangleCopy11' },
  { name: '分享', icon: '&#xe6ad;', code: 'fenxiang' },
  { name: '收起', icon: '&#xe6af;', code: 'RectangleCopy14' },
  { name: 'Smile', icon: '&#xe6b0;', code: 'smile' },
  { name: '设置/管理', icon: '&#xe6b1;', code: 'RectangleCopy16' },
  { name: '编辑', icon: '&#xe6b2;', code: 'bianji' },
  { name: '减', icon: '&#xe6b4;', code: 'Rectangle' },
  { name: '健康', icon: '&#xe6b5;', code: 'RectangleCopy19' },
  { name: '加', icon: '&#xe6b6;', code: 'RectangleCopy20' },
  { name: '逆向', icon: '&#xe6b7;', code: 'RectangleCopy21' },
  { name: '关闭', icon: '&#xe6b8;', code: 'RectangleCopy22' },
  { name: '仓库', icon: '&#xe6b9;', code: 'RectangleCopy23' },
  { name: '发布', icon: '&#xe6ba;', code: 'RectangleCopy24' },
  { name: '工具箱', icon: '&#xe6bb;', code: 'RectangleCopy25' },
  { name: '删除', icon: '&#xe6bc;', code: 'RectangleCopy26' },
  { name: '目录', icon: '&#xe6bd;', code: 'RectangleCopy27' },
  { name: '用户管理', icon: '&#xe6be;', code: 'RectangleCopy28' },
  { name: '人群', icon: '&#xe6bf;', code: 'RectangleCopy29' },
  { name: 'Viewlist', icon: '&#xe6c0;', code: 'viewlist' },
  { name: '系统返回', icon: '&#xe6c1;', code: 'xitongfanhui' },
  { name: '系统菜单', icon: '&#xe6c2;', code: 'xitongcaidan' },
  { name: 'discount', icon: '&#xe6c5;', code: 'discount' },
  { name: 'service', icon: '&#xe6c7;', code: 'service' },
  { name: '首页', icon: '&#xe6cb;', code: 'shouye' },
  { name: '提醒', icon: '&#xe6cc;', code: 'tixing' },
  { name: 'gifts', icon: '&#xe6db;', code: 'gifts' },
  
  // 扩展图标（使用e9xx系列）
  { name: '版权', icon: '&#xe98b;', code: 'banquan' },
  { name: '安全隐私', icon: '&#xe98c;', code: 'anquanyinsi' },
  { name: '饼图图表', icon: '&#xe98f;', code: 'bingtutubiao' },
  { name: '查验', icon: '&#xe991;', code: 'chayan' },
  { name: '二维码', icon: '&#xe992;', code: 'erweima' },
  { name: '分布式', icon: '&#xe994;', code: 'fenbushi' },
  { name: '订单', icon: '&#xe996;', code: 'dingdan' },
  { name: '服务器', icon: '&#xe997;', code: 'fuwuqi' },
  { name: '分支', icon: '&#xe998;', code: 'fenzhi' },
  { name: '丰富多元', icon: '&#xe999;', code: 'fengfuduoyuan' },
  { name: '合同', icon: '&#xe99b;', code: 'hetong' },
  { name: '精确准确', icon: '&#xe9a2;', code: 'jingquezhunque' },
  { name: '开放', icon: '&#xe9a4;', code: 'kaifang' },
  { name: '管理', icon: '&#xe9aa;', code: 'guanli' },
  { name: '平台', icon: '&#xe9ac;', code: 'pingtai' },
  { name: '全领域规模', icon: '&#xe9ae;', code: 'quanlingyuguimo' },
  { name: '扫码', icon: '&#xe9af;', code: 'saoma' },
  { name: '商业化全球', icon: '&#xe9b2;', code: 'shangyehuaquanqiu' },
  { name: '身份认证', icon: '&#xe9b3;', code: 'shenfenrenzheng' },
  { name: '时间周期', icon: '&#xe9b4;', code: 'shijianzhouqi' },
  { name: '时间戳', icon: '&#xe9b5;', code: 'shijianchuo' },
  { name: '数字化', icon: '&#xe9b6;', code: 'shuzihua' },
  { name: '图片', icon: '&#xe9b7;', code: 'tupian' },
  { name: '图表柱图', icon: '&#xe9b9;', code: 'tubiaozhutu' },
  { name: '数据库', icon: '&#xe9bb;', code: 'shujuku' },
  { name: '网络', icon: '&#xe9bc;', code: 'wangluo' },
  { name: '银行', icon: '&#xe9c1;', code: 'yinhang' },
  { name: '身份识别认证', icon: '&#xe9c3;', code: 'shenfenshibierenzheng' },
  { name: '应用场景', icon: '&#xe9c4;', code: 'yingyongchangjing' },
  { name: '隐私保护', icon: '&#xe9c5;', code: 'yinsibaohu' },
  { name: '数据监管', icon: '&#xe9c6;', code: 'shujujianguan' },
  { name: '真实可信', icon: '&#xe9c7;', code: 'zhenshikexin' },
  { name: '印章认证', icon: '&#xe9c8;', code: 'yinzhangrenzheng' },
  { name: '文档', icon: '&#xe9c9;', code: 'wendang' },
  { name: '证照执照', icon: '&#xe9cb;', code: 'zhengzhaozhizhao' },
  
  // 其他可用图标
  { name: '热门', icon: '&#xe8c9;', code: 'remen' },
  { name: 'textile-products', icon: '&#xe882;', code: 'textile-products' },
  { name: 'trust', icon: '&#xe82a;', code: 'trust' },
  { name: 'hot', icon: '&#xe756;', code: 'hot' },
  { name: 'survey', icon: '&#xe74e;', code: 'survey' },
  { name: 'libra', icon: '&#xe74c;', code: 'libra' },
  { name: 'credit-level', icon: '&#xe735;', code: 'creditlevel' },
  { name: 'bussiness-man', icon: '&#xe726;', code: 'bussinessman' },
  { name: 'assessed-Badge', icon: '&#xe70a;', code: 'assessedbadge' },
];

const IconSelector: React.FC<IconSelectorProps> = ({
  visible,
  onClose,
  onSelect,
  currentIcon
}) => {
  const [searchText, setSearchText] = useState('');
  const [selectedIcon, setSelectedIcon] = useState<string>(currentIcon || '');

  // 监听currentIcon变化，更新selectedIcon
  useEffect(() => {
    setSelectedIcon(currentIcon || '');
  }, [currentIcon]);

  // 过滤图标
  const filteredIcons = iconList.filter(icon => 
    icon.name.includes(searchText) || icon.code.includes(searchText)
  );

  const handleSelect = (icon: string) => {
    setSelectedIcon(icon);
  };

  const handleConfirm = () => {
    if (selectedIcon) {
      onSelect(selectedIcon);
      onClose();
    } else {
      message.warning('请选择一个图标');
    }
  };

  return (
    <Modal
      title="选择图标"
      open={visible}
      onCancel={onClose}
      onOk={handleConfirm}
      width={800}
      okText="确定"
      cancelText="取消"
    >
      <div style={{ marginBottom: 16 }}>
        <Input
          placeholder="搜索图标名称或代码"
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>
      
      <div style={{ maxHeight: 400, overflowY: 'auto' }}>
        <Row gutter={[8, 8]}>
          {filteredIcons.map((icon, index) => {
            const isSelected = selectedIcon === icon.icon;
            return (
            <Col span={6} key={index}>
              <div
                style={{
                  padding: '8px',
                  border: isSelected ? '2px solid #1890ff' : '1px solid #d9d9d9',
                  borderRadius: '4px',
                  textAlign: 'center',
                  cursor: 'pointer',
                  backgroundColor: isSelected ? '#e6f7ff' : '#fff',
                }}
                onClick={() => handleSelect(icon.icon)}
              >
                <div style={{ fontSize: '20px', marginBottom: '4px' }}>
                  <i className="iconfont" dangerouslySetInnerHTML={{ __html: icon.icon }} />
                </div>
                <div style={{ fontSize: '12px', color: '#666' }}>
                  {icon.name}
                </div>
              </div>
            </Col>
            );
          })}
        </Row>
      </div>
    </Modal>
  );
};

export default IconSelector;
